import { render, staticRenderFns } from "./ProfileIdeas.vue?vue&type=template&id=61f6c3bd&"
import script from "./ProfileIdeas.vue?vue&type=script&lang=js&"
export * from "./ProfileIdeas.vue?vue&type=script&lang=js&"
import style0 from "./ProfileIdeas.vue?vue&type=style&index=0&id=61f6c3bd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports